/** Every error code in requirements §11.6 (plus generic HTTP-level codes). */
export const ERROR_CODES = [
  'VALIDATION_FAILED',
  'FORBIDDEN_ROLE',
  'EDIT_WINDOW_EXPIRED',
  'REF_NOT_FOUND',
  'ANIMAL_INACTIVE',
  'DATE_IN_FUTURE',
  'CONFLICT_UNIQUE',
  'HAS_DEPENDENTS',
  'PRICE_LOCKED',
  'WITHHELD_OVERRIDE_FORBIDDEN',
  'EXPENSE_FROM_EVENT',
  'TENANT_MISMATCH',
  'UNKNOWN_ENTITY',
  'SHARES_EXCEED_100',
  'DISTRIBUTION_MISMATCH',
  'INVALID_CREDENTIALS',
  'ACCOUNT_LOCKED',
  'ACCOUNT_INACTIVE',
  'SESSION_REVOKED',
  'UNAUTHENTICATED',
  'NOT_FOUND',
  'RATE_LIMITED',
  'INTERNAL_ERROR',
] as const;

export type ErrorCode = (typeof ERROR_CODES)[number];

export function isErrorCode(s: unknown): s is ErrorCode {
  return typeof s === 'string' && (ERROR_CODES as readonly string[]).includes(s);
}

/** API error body: `{ "error": { "code", "message", "details"? } }` (requirements §12). */
export interface ApiErrorBody {
  error: { code: ErrorCode; message: string; details?: unknown };
}
